<img width="100%" src="/eca_strip.png" alt="" class="eca-strip" style="margin-top: 15px"/>
<img width="20%" src="/eca_logo_rectangle.png" alt="" class="eca-logo"/>

<div style="margin-left: 10px">

  <h5 class="eca-primary-text" style="margin-top: 100px">
    Please read this Acceptance statement and our Agreement carefully before proceeding:
  </h5>

  <ol>
    <li>
      Our Agreement is comprised of this Acceptance, the ECA Software Terms and the other documents incorporated into our Agreement as described in the ECA Software Terms copies of which are located at <a href="https://www.eca.co.uk/eca-software-support" target="_blank">https://www.eca.co.uk/eca-software-support</a>.
    </li>
    <li>
      By clicking ‘Accept’ you accept our Agreement on behalf of the Customer indicated in this Acceptance as a legally binding contract with ECA.
    </li>
    <li>
      You represent and warrant that you have all necessary capacity and authority to enter into our Agreement on behalf of the Customer as a legally binding contract with ECA in all applicable jurisdictions. If you do not have such capacity or authority or do not wish to accept this Agreement on behalf of the Customer please select the ‘Decline’ option before proceeding to request the provision of Services.
    </li>
    <li>
      Defined terms in this Acceptance shall have the meaning given in the ECA Software Terms as applied by our Agreement and the rules of interpretation set out in the ECA Software Terms apply to this Acceptance unless otherwise agreed. References to this Acceptance include its schedules, annexes and appendices (if any).
    </li>
    <li>
      Any Special Terms included herein shall vary and prevail over any conflicting terms in any other part of our Agreement, including any other part of this Acceptance.
    </li>
    <li>
      Where the Customer is a Member all Subscribed Services are available to the Customer for the duration of the period during which they remain a Member at zero cost for an unlimited number of Authorised Users. For the avoidance of doubt, if the Customer ceases to be a Member this Agreement will terminate, and in order to continue to subscribe to the Services, the Customer will need to enter into a new Agreement with ECA.
    </li>
    <li>
      There are Support Services available for each Subscribed Service to the Customer for the duration of the respective Subscribed Service Period. To contact these Support Services email ecoms@eca.co.uk
    </li>
    <li>In this Acceptance:
      <div class="container-fluid" style="margin-top: 10px">
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">Customer</span>
          </div>
          <div class="col-md-9">
            <p>is any ECA Member.</p>
            <p>Notices to the Customer will be sent to their nominated representative as identified to ECA within the ECA rules and also to the eCOMS contacts maintained within the eCOMS system.</p>
            <p>Physical address for notices to the Customer: <span class="order-form-contact">{{ company?.inlineAddress }}</span></p>
            <p>Such contact details may be updated from time to time by the Customer in accordance with the process set out in the ECA Software Terms.</p>
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">ECA</span>
          </div>
          <div class="col-md-9">
            as defined in the ECA Software Terms
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">ECA Software Terms</span>
          </div>
          <div class="col-md-9">
            means the latest version of the document available at <a href="https://www.eca.co.uk/eca-software-support" target="_blank">https://www.eca.co.uk/eca-software-support</a>, as Updated from time to time;
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">Member</span>
          </div>
          <div class="col-md-9">
            as defined in the ECA Software Terms
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">Subscription Service Specific Terms</span>
          </div>
          <div class="col-md-9">
            means any terms set out within this Acceptance and identified to applied to specific Subscribed Services; and
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-3 text-left">
            <span class="order-form-term">Subscribed Territory</span>
          </div>
          <div class="col-md-9">
            United Kingdom and Channel Islands
          </div>
        </div>
      </div>
    </li>
  </ol>


</div>
